import isEqual from 'fast-deep-equal'; // optional, sonst eigene deepEqual Funktion
import { computed, ref } from 'vue';

export function useDirtyRef<T>(value: T) {
  const currentlValue = ref(value)
  const initialValue = ref(structuredClone(value))

  const isDirty = computed(() => {
    return !isEqual(currentlValue.value, initialValue.value)
  })

  const reset = () => {
    currentlValue.value = structuredClone(initialValue.value)
  }

  const resetDirtyState = () => {
    initialValue.value = structuredClone(currentlValue.value);
  }

  return {
    get value(): T | null {
      return currentlValue.value
    },
    set value(val: T) {
      currentlValue.value = val
    },
    isDirty,
    reset,
    resetDirtyState
  }
}
